<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.container {
  background: #03006c;
}

.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_4.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.eqs::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <div class="container" ref="contianer" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;display: flex;padding: 20px;padding-top: 10px;">
    <div ref="eqs" class="biankuang eqs" style="width: 100%;box-sizing: border-box;display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr ;grid-gap: 10px;flex:1;padding: 20px;overflow: auto;">
      <div @click="currentEq = eq; isShowEqEditDialog = true" v-for="(eq, index) in list" style="background: rgba(6, 0, 149, 1);display: flex;flex-direction: column;height: 248px;border-radius: 6px;overflow: hidden;;">
        <div style="width: 100%;height: 8px;" :style="{ background: getBarColor(eq.status) }"></div>
        <div style="padding: 8px 8px;" :style="{ color: getTextColor(eq.status) }">
          <p style="font-weight: bold;font-size: 26px;">{{ eq.equipmentName }}</p>
          <p style="font-size: 16px;">用料量：{{ eq.material ? (eq.material / 1000).toFixed(2) : '-' }}kg</p>
          <div style="font-size: 14px;line-height: 24px;">
            <p style="color: white;">
              出水压力<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.intoWaterPressure ? eq.intoWaterPressure : '-' }}mpa</span>
            </p>
            <p style="color: white;">
              出水温度<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.intoWaterTemperature ? eq.intoWaterTemperature : '-' }}℃</span>
            </p>
            <p style="color: white;">
              回水压力<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.backWaterPressure ? eq.backWaterPressure : '-' }}mpa</span>
            </p>
            <p style="color: white;">
              回水温度<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.backWaterTemperature ? eq.backWaterTemperature : '-' }}℃</span>
            </p>
            <p style="color: white;">
              液压油温<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.oilTemperature ? eq.oilTemperature : '-' }}℃</span>
            </p>
            <p style="color: white;">
              模具回水流量<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ eq.flow ? eq.flow : '-' }}m³/h</span>
            </p>
            <p style="color: white;">
              模具回水流量SV<span :style="{ color: getTextColor(eq.status) }" style="margin-left: 6px;">{{ currencyRule && currencyRule[eq.equipmentId + ''] }}m³/h</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :show-close="true" :visible.sync="isShowEqEditDialog" :close-on-click-modal="false" width="380px" append-to-body>
      <div style="width: 100%;padding: 20px;padding-bottom: 40px;">
        <el-form :inline="true" ref="form" size="mini" :label-width="120">
          <el-form-item class="noborder" :label="$t('shebeimingcheng')">
            {{ currentEq.equipmentName }}
          </el-form-item>
          <el-form-item class="noborder" :label="$t('模具回水流量SV')">
            <el-input-number :precision="1" :min="0" :step="0.1" :controls="false" size="mini" v-model="currencyRule[currentEq.equipmentId + '']"> </el-input-number>
          </el-form-item>
        </el-form>
        <div>
          <el-button size="mini" @click="isShowEqEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="saveCurrencyRule" type="primary">{{ $t('baocun') }}
          </el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_customize_yongxin_monitor_mes_liaodou_index',
  components: {},

  data() {
    return {
      currencyRule: {},
      isShowEqEditDialog: false,
      currentEq: {},
      timer: null,
      list: []
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();

    this.getCurrencyRule()
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getBarColor(status) {
      if (status == '0') {
        return 'linear-gradient(270deg, #6FE6D0 0%, #356DFB 100%)';
      } else if (status == '3') {
        return ' linear-gradient(270deg, #E455D6 0%, #FF3A75 100%)';
      } else if (status == '1') {
        return 'linear-gradient(270deg, #FFD057 0%, #E49155 100%)';
      } else if (status == null || status == '-1') {
        return 'linear-gradient(270deg, #858FA3 0%, #333333 100%)';
      }
    },
    getTextColor(status) {
      if (status == '0') {
        return 'rgba(58, 220, 255, 1)';
      } else if (status == '3') {
        return 'rgba(255, 58, 117, 1)';
      } else if (status == '1') {
        return 'rgba(255, 200, 58, 1)';
      } else if (status == null || status == '-1') {
        return 'rgba(170, 179, 204, 1)';
      }
    },
    async listData() {
      let response = await this.http.get('/custom/yongxin/report/equipment/ingredient/list', {});
      this.list = response.data;
    },
    async getCurrencyRule() {
      let response = await this.http.get('/web/setting/parameter/getCurrencyRule', {
        params: {
          code: "YONGXIN_MES_MONITOR_EQ_HUISHUI"
        }
      });
      console.log(response.data.value)
      if (response.data.value) {
        this.currencyRule = JSON.parse(response.data.value)
      }
    },
    async saveCurrencyRule() {
      let response = await this.http.post('/web/setting/parameter/setCurrencyRule', {
        code: "YONGXIN_MES_MONITOR_EQ_HUISHUI",
        value: JSON.stringify(this.currencyRule)
      });
      this.isShowEqEditDialog = false
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.eqs;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    }
  }
};
</script>
